import { fetchAllPrices } from "@/services/lukita/prices";

export default async function pricesLoader() {
  const prices = fetchAllPrices();

  return { prices };
}
